import cn from "classnames"

import { Col, Row } from "@/atoms"
import useServices from "@/hooks/useServices"
import { HighProfileVulnerability } from "@/organisms/HighProfileVulnerability"
import { AgeOpenIssueWidget } from "@/pages/DashboardPage/components/organisms/AgeOpenIssueWidget"
import { DiscoveredClosedIssuesWidget } from "@/pages/DashboardPage/components/organisms/DiscoveredClosedIssuesWidget"
import { ResolvedIssuesMTTR } from "@/pages/DashboardPage/components/organisms/ResolvedIssuesMTTR"
import { PageTemplate } from "@/templates/PageTemplate"
import { HeaderDashboardPage } from "./components/molecules/HeaderDashboardPage/HeaderDashboardPage"
import { AdrIncidentsWidget } from "./components/organisms/AdrIncidentsWidget"
import { FunnelDashboard } from "./components/organisms/FunnelDashboard"
import { InventorySnapshotWidget } from "./components/organisms/InventorySnapshotWidget"
import PostureScoreWidget from "./components/organisms/PostureScoreWidget"
import { RemediationActivityWidget } from "./components/organisms/RemediationActivityWidget"
import { RemediationCoverageWidget } from "./components/organisms/RemediationCoverageWidget"
import { TopIssuesWidget } from "./components/organisms/TopIssuesWidget"
import { VulnerableFunctionInRuntimeWidget } from "./components/organisms/VulnerableFunctionInRuntimeWidget"
import useDashboard from "./hooks/useDashboard"

import styles from "./DashboardPage.module.scss"

export const DashboardPage = () => {
  const { runtime, postureProps, inventorySnapshotProps, funnelProps } =
    useDashboard()
  const { auth } = useServices()
  const isDemo = auth.isDemo()
  const scoreWidgetProps = isDemo ? { flex: "auto" } : { lg: 13, sm: 24 }
  const RIGHT_WIDGET_WIDTH = "376px"
  const inventorySnapshotWidgetProps = isDemo
    ? { flex: `0 0 ${RIGHT_WIDGET_WIDTH}` }
    : { lg: 11, sm: 24 }

  return (
    <PageTemplate
      header={<HeaderDashboardPage />}
      classes={{ main: cn(isDemo && styles.demoMain) }}
    >
      <Row gutter={[0, 24]} className={styles.demoSection}>
        <Col span={24}>
          <HighProfileVulnerability placement="dashboard" />
        </Col>
        {isDemo && (
          <Col span={24}>
            <InventorySnapshotWidget isDemo {...inventorySnapshotProps} />
          </Col>
        )}
      </Row>
      <Row gutter={16} className={styles.firstSection} wrap={false}>
        <Col {...scoreWidgetProps}>
          <PostureScoreWidget {...postureProps} />
        </Col>
        <Col {...inventorySnapshotWidgetProps}>
          {isDemo && <AdrIncidentsWidget />}
          {!isDemo && <InventorySnapshotWidget {...inventorySnapshotProps} />}
        </Col>
      </Row>
      <Row gutter={16} className={styles.secondSection}>
        <Col flex="auto">
          <FunnelDashboard {...funnelProps} />
        </Col>
        {!isDemo && (
          <Col flex={`0 0 ${RIGHT_WIDGET_WIDTH}`}>
            <VulnerableFunctionInRuntimeWidget />
          </Col>
        )}
      </Row>
      {isDemo && (
        <Row
          gutter={16}
          className={cn(
            styles.demoSection,
            styles.demoSectionHeight,
            styles.demoSectionRemediation
          )}
        >
          <Col span={16}>
            <RemediationActivityWidget
              title="Remediation Activity"
              subTitle="Last 30 days"
              isLoading={postureProps.isLoading}
            />
          </Col>
          <Col span={8}>
            <RemediationCoverageWidget
              title="Remediation Coverage"
              isLoading={postureProps.isLoading}
            />
          </Col>
        </Row>
      )}
      <Row gutter={16} className={styles.discoveredCloseIssues}>
        <Col span={24}>
          <DiscoveredClosedIssuesWidget />
        </Col>
      </Row>
      <Row gutter={16} className={styles.firstSection}>
        <Col lg={11} sm={24}>
          <ResolvedIssuesMTTR />
        </Col>
        <Col lg={13} sm={24}>
          <AgeOpenIssueWidget />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <TopIssuesWidget runtime={runtime} />
        </Col>
      </Row>
    </PageTemplate>
  )
}
